import React from 'react';

import { StyleProp, TextStyle } from 'react-native';

import { isWeb } from 'utils/responsiveness';

import Text, { ETextCategory, ETextColor } from 'components/Text/index';

type Props = {
    text: string;
    style?: StyleProp<TextStyle>;
    category?: ETextCategory;
    color?: ETextColor;
};

const createKey = (text: string, index: number) => `${text}-${index}`;

function TextWithBoldPhoneNumbers({ text, style, category, color }: Props) {
    const phoneRegex =
        /(\+?\d{1,4}\s*[()]*\d{1,4}\s*[()]*[\s-./]?\d{2,5}[\s-./]?\d{2,5}\s*[\d-]*)/g;

    const formattedText = text.split(phoneRegex).map((chunk, index) => {
        if (phoneRegex.test(chunk)) {
            return (
                <Text key={createKey(chunk, index)} bold>
                    {chunk}
                </Text>
            );
        }

        return <Text key={createKey(chunk, index)}>{chunk}</Text>;
    });

    return (
        <Text
            style={style}
            category={category}
            color={color}
            {...(isWeb && { tabIndex: 0 })}
        >
            {formattedText}
        </Text>
    );
}

export default TextWithBoldPhoneNumbers;
